import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import {setCookie,getCookie,delCookie} from '../common/js/cookie.js'


Vue.use(Vuex)

// 应用初始状态
const state = {
    count: 10,
    groupid:getCookie('groupid'),
    user:getCookie('user'),
}


// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        state.count++
    },
    DECREMENT(state) {
        state.count--
    },
    SETGROUPID(state,groupid){
    	state.groupid=groupid;
    },
    SETUSER(state,user){
    	state.user=user
    }
    
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    config:{},
    applist:[],
    vlist:[],
    plist:[],
    mutations,
    isPhone:false,
})


// WEBPACK FOOTER //
// ./src/vuex/store.js